import { render, staticRenderFns } from "./WigeLivetiming.vue?vue&type=template&id=f4b16df0&"
import script from "./WigeLivetiming.vue?vue&type=script&lang=js&"
export * from "./WigeLivetiming.vue?vue&type=script&lang=js&"
import style0 from "./WigeLivetiming.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports